import axios from 'axios'
import { Message } from 'element-ui';
import { MessageBox } from 'element-ui';
import router from '../router'
import http from './http';

axios.defaults.timeout = 20000;
axios.defaults.headers = {
   "Content-Type": "application/json",
}
axios.defaults.baseURL = http.httpURL; 

axios.defaults.transformResponse = [function(data) {//处理返回的数据
    var objData = JSON.parse(data);
    return objData;
}];

axios.interceptors.request.use(config => {//http请求拦截
    // console.log(config.headers)
    if(localStorage.getItem('USER')){
        // console.log(JSON.parse(localStorage.getItem("USER")))
        if(config.url == "https://up-z2.qbox.me"){
            return config
        }else if(config.url == "manager/send/sendMsg" || config.url == "user/home/setBalanceSizeWarn"){
            config.headers['Authorization'] = JSON.parse(localStorage.getItem("USER")).token;
            return config
        }
        config.headers['Authorization'] = JSON.parse(localStorage.getItem("USER")).token;
        
        // config.url = config.url + '?token=' + JSON.parse(localStorage.getItem("USER")).token;
    }else{
        console.log(this.$router)
    }
    config.data=JSON.stringify(config.data);
    return config
}, error => {
    Message.error("连接服务器失败")
    return Promise.reject(error)
})
axios.interceptors.response.use(response => {//http响应拦截器异常处理
    return response
}, error => {
    if (error && error.status) {
        switch (error.status) {
            case 400:
            error.message = '错误请求'
                break;
            case 403:
            error.message = '拒绝访问'
                break;
            case 404:
            error.message = '请求错误,未找到该资源'
                break;
            case 405:
            error.message = '请求方法未允许'
                break;
            case 408:
            error.message = '请求超时'
                break;
            case 500:
            error.message = '服务器端出错'
                break;
            case 501:
            error.message = '网络未实现'
                break;
            case 502:
            error.message = '网络错误'
                break;
            case 503:
            error.message = '服务不可用'
                break;
            case 504:
            error.message = '网络超时'
                break;
            case 505:
            error.message = 'http版本不支持该请求'
                break;
            default:
            error.message = `连接错误${err.response.status}`
        }
    } else {
        error.message = "连接到服务器失败"
    }
    Message.error({
        message: error.message
    })
    return Promise.resolve(error.response)
})
function checkStatus(response) {
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response
    }else{
        return statusCode(response)
    }
}
function checkCode(res) {
    // 如果异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
    if (res.status === 200 && res.data.status === "error") {
        Message.error(res.data.msg)
    } else if (res.status === 200 && res.data.status === "401"){
        MessageBox.alert("登录过期，请重新登录", {
            confirmButtonText: '确定',
            center: true,
            callback: function(){
                router.push({
                    path: "/index"
                });
                window.location.reload()
            }
        })
    }
    return res
}
export default {
    post(url, data, config) {
        return axios.post(url, {}, Object.assign(data, config)).then(
            (response) => {
                return checkStatus(response)
            }
        ).then(
            (res) => {
                return checkCode(res)
            }
        )
    },
    get(url, data, config) {
        return axios.get(url, Object.assign(data, config)).then(
            (response) => {
                return checkStatus(response)
            }
        ).then(
            (res) => {
                return checkCode(res)
            }
        )
    },
}



// WEBPACK FOOTER //
// ./src/server/service.js